module.exports = __webpack_public_path__ + "static/media/OP50.99638c30.png";